export default "__VITE_ASSET__jMEelQbK__"